import { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HTTP_TOO_MANY_REQUESTS = 429;
const EMPTY_FORM = { name: '', email: '', subject: '', message: '' };

function extractErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length) {
    return detail
      .map((d) => (d?.msg ? `${(d.loc || []).slice(-1)[0] || 'field'}: ${d.msg}` : String(d)))
      .join('; ');
  }
  if (err?.response?.status === HTTP_TOO_MANY_REQUESTS) {
    return 'Too many messages sent from your IP. Please try again in a minute.';
  }
  return 'Could not send your message. Please try again.';
}

/**
 * State + submission wiring for the public contact form. Keeps the
 * Contact page purely presentational.
 */
export function useContactForm() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handle = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      setForm(EMPTY_FORM);
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return { form, submitting, sent, error, handle, submit };
}
